var paragraph_default = {
  "fontElementMap": "PKXeB",
  "elementSpacing": "i1-1t",
  "text": "_48tL5 i1-1t",
  "child": "E-T7K"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
